export const trailLogFields = `
  id
  changes
  date
  entityId
  entityType
  event
  meta
  updatedAt
  whodunnit {
    email
    firstName
    lastName
  }
`;
